var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"data"}},[_c('el-tag',[_vm._v("欢迎使用本系统")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }